import {
  AA_SUPPORTED_EVM_CHAINS,
  ALLCHAINS,
  GAS_ABS_ENABLED_CHAINS,
  SUPPORTED_EVM_CHAINS,
  TESTNET_CHAINS,
} from "./chains";

export const prodApiUrl = "https://production.tria.so";
const solanaRegex = /^[1-9A-HJ-NP-Za-km-z]{32,44}$/;
const injectiveRegex = /^inj1[a-zA-Z0-9]{38}$/;
const bitcoinRegex = /^bc1q[a-zA-Z0-9]{38}$/;

export const isEvmChain = (chainName: string) => {
  return SUPPORTED_EVM_CHAINS.includes(chainName) || chainName == "EVM";
};

export const isAaSupportedChain = (chainName: string) => {
  return AA_SUPPORTED_EVM_CHAINS.includes(chainName);
};

export const isChainSupported = (chainName: string) => {
  return ALLCHAINS.includes(chainName) || chainName == "EVM";
};

export const isTestnetChain = (chainName: string) => {
  return TESTNET_CHAINS.includes(chainName) || chainName == "EVM";
};

export const isGasAbsEnabled = (chainName: string) => {
  return GAS_ABS_ENABLED_CHAINS.includes(chainName);
};

export const getChainNameFromAddress = (
  address?: string
): {
  isValidAddress: boolean;
  chainName: "EVM" | "TRIANAME" | "SOLANA" | "INJECTIVE" | "BITCOIN" | "NONE";
} => {
  if (!address) {
    return { isValidAddress: false, chainName: "NONE" };
  }

  const isTriaName = address?.includes("@");
  if (isTriaName) {
    return { isValidAddress: true, chainName: "TRIANAME" };
  }

  if (isSolanaAddress(address)) {
    return { isValidAddress: true, chainName: "SOLANA" };
  }

  if (isInjectiveAddress(address)) {
    return { isValidAddress: true, chainName: "INJECTIVE" };
  }

  if (isEvmAddress(address)) {
    return { isValidAddress: true, chainName: "EVM" };
  }

  if (isBitcoinAddress(address)) {
    return { isValidAddress: true, chainName: "BITCOIN" };
  }

  return { isValidAddress: false, chainName: "NONE" };
};

export const isSolanaAddress = (address: string) => {
  return solanaRegex.test(address);
};

export const isInjectiveAddress = (address: string) => {
  return injectiveRegex.test(address);
};

export const isEvmAddress = (address: string) => {
  return address.startsWith("0x");
};

export const isBitcoinAddress = (address: string) => {
  return bitcoinRegex.test(address);
};
